
export enum SlideAction {
	Add,
	Remove,
	LeftToRightExtend,
	MiddleExtend,
	RightToLeftExtend,
}